import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useHistory, useParams } from 'react-router-dom'

import { deleteDocument } from './redux/actions'
import { ApplicationState } from 'AppReducer'

type DocOpts = {
  person?: number,
  hideEmpty?: boolean
  disableActions?: boolean
}
const DocumentList: React.FC<DocOpts> = ({ person, hideEmpty = false, disableActions = false }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { personId: routePerson } = useParams<{ personId: string }>()
  const { documents } = useSelector((state: ApplicationState) => state.userDocumentReducer)

  const personId = routePerson || person

  function handleRemove (id: number): void {
    if (personId && window.confirm('Tem certeza que deseja remover?')) {
      deleteDocument(personId, id)(dispatch).then(res => {
        if (res?.status === 'success') {
          history.push(person ? '/panel/profile' : `/panel/person/${personId}/document`)
        }
      })
    }
  }

  if (hideEmpty && !documents.length) {
    return null
  }

  return (
    <div className="row justify-start margin-top-32">
      <h2>Documentos Cadastrados</h2>
      {
        documents.length === 0 &&
        <p className="row empty">Nenhum documento cadastrado</p>
      }

      {
        documents.map(document => (
          <div className="row tile" key={document.id}>
            <div className="grow">
              <div className="row">
                <div className="row col-6">
                  <p className="col-12 bold">Tipo</p>
                  <p className="col-12 no-margin">{ document.type }</p>
                </div>
                <div className="row col-6">
                  <p className="col-12 bold">Número</p>
                  <p className="col-12 no-margin">{ document.value }</p>
                </div>
              </div>
            </div>
            {
              !disableActions &&
              <>
                <span
                  style={{ width: 48 }}
                  onClick={(): void => handleRemove(document.id)}
                  className="button remove margin-right-8"
                >
                  <i className="fa fa-trash"/>
                </span>
                <NavLink
                  style={{ width: 48 }}
                  className="button primary"
                  to={
                    person
                      ? `/panel/profile/document/${document.id}/edit`
                      : `/panel/person/${personId}/document/${document.id}/edit`
                  }
                >
                  <i className="fa fa-edit"/>
                </NavLink>
              </>
            }
          </div>
        ))
      }
    </div>
  )
}

export default DocumentList
